export function monkeyPatchFragmentLoadMethod(hlsPlayer: any): void {
	if (hlsPlayer.isFragLoadWorker) {
		monkeyPatchTsLoader(hlsPlayer);
		monkeyPatchVttLoader(hlsPlayer);
	}
}

function monkeyPatchTsLoader(hlsPlayer: any): void {
	const fragmentLoader = hlsPlayer.player.networkControllers.find(controller => controller.playlistType === 'main').fragmentLoader;
	if (!fragmentLoader) {
		return;
	}
	monkeyPatchLoadMethod(fragmentLoader);
}

function monkeyPatchVttLoader(hlsPlayer: any): void {
	const fragmentLoader = hlsPlayer.player.networkControllers.find(controller => controller.playlistType === 'subtitle').fragmentLoader;
	if (!fragmentLoader) {
		return;
	}
	monkeyPatchLoadMethod(fragmentLoader);
}

function monkeyPatchLoadMethod(fragmentLoader: any) {
	const originalFunction = fragmentLoader.load;
	fragmentLoader.load = function(...args: any[]) {
		const frag = args[0];
		this.config.fragType = frag.type;
		return originalFunction.apply(this, args);
	};
}
